
import { defineComponent, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import AppNoAuthContainer from '@/components/AppNoAuthContainer.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import { killFirestoreListeners, initSyncFirestoreWithVuexStore } from '@/utils';

export default defineComponent({
  name: 'JoinGroupWithLink',
  components: {
    AppNoAuthContainer,
    ButtonInput
  },
  props: {
    linkId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const groupName = ref('');
    const isDoneTryingToGetGroupName = ref(false);

    onBeforeMount(async () => {
      store.dispatch.internal.update(['isLoading', true]);
      try {
        groupName.value = await store.dispatch.groups.getGroupNameByLinkId(props.linkId);
      } finally {
        isDoneTryingToGetGroupName.value = true;
        store.dispatch.internal.update(['isLoading', false]);
      }
    });

    const acceptInvite = async () => {
      if (!store.getters.auth.isSignedIn) {
        await store.dispatch.auth.signIn();
      }

      if (store.getters.groups.getGroupId) {
        await router.push('/bids');
      }

      store.dispatch.internal.update(['isLoading', true]);
      await store.dispatch.groups.joinWithGroupLink(props.linkId);
      await killFirestoreListeners();
      await initSyncFirestoreWithVuexStore();
      store.dispatch.internal.update(['isLoading', false]);
      await router.push('/bids');
    };

    const declineInvite = () => router.push('/');

    return {
      groupName,
      acceptInvite,
      declineInvite,
      isDoneTryingToGetGroupName
    };
  }
});
